import Authorize from './Authorize';
import Logout from './Logout';

export const routes = [
	{
		path: '/authorize',
		name: 'authorize',
		component: Authorize
	},
	{
		path: '/logout/:name?',
		name: 'logout',
		component: Logout
	}
];

export default routes;
